import React from 'react';
import styled from '@emotion/styled';
import { colors, device } from './layout/GlobalStyles';
import { StaticImage } from 'gatsby-plugin-image';
import { Button } from './layout/StyledComponents';
import rectangle from '../images/svgs/rectangle.svg';
import girl from '../images/homepage.jpg';
import { css, cx } from '@emotion/css';

const reviews = [
    {
        review: 'I’m so happy to stumble upon this place. Not only do they use state of the art equipment, the furnishings are absolutely gorgeous and luxurious! Dr. Kasey is amazing too!!...',
        name: 'Char Russ',
    },
    {
        review: 'Such a great experience!  Very caring and kind staff, everyone was professional and personable.  The office was so clean and high- tech!  I am so happy I found Dr. Kasey!',
        name: `Lisa O'Malley`,
    },
    {
        review: 'Dr. Kasey and her entire team were absolutely wonderful! The best dental practice I have been to. Would recommend them hands down. Super nice, accommodating and they ...',
        name: `Daniel McGuirk`,
    },
];

const StyledHomeTestimonials = styled.div`
    padding: 0em 0.75em 2em;
    .scroll-container {
        overflow-x: scroll;
    }

    h2 {
        margin: 0em 0em 1em;
    }
    .container {
        position: relative;
    }

    .quote {
        z-index: 1;
        top: 1.3em;
        left: 2.25em;
        position: relative;
    }
    .box {
        background: ${colors.white};
        min-width: 310px;
        margin: 0em 0.5em;
        padding: 1.5em 1em;
        p {
            padding: 0em 2em 0.75em 1em;
        }
        span {
            color: ${colors.gold};
            padding-left: 1em;
            font-weight: 700;
        }
    }
    .scroll {
        display: flex;
        width: 150vw;
    }
    @media ${device.tablet} {
        padding: 0em 0.75em 4em;

        .scroll-container {
            overflow: scroll;
        }
        .scroll {
            margin: 0 auto;
            width: 100vw;
        }
        h2 {
            text-align: left;
            padding-left: 0.5em;
        }
        .box {
            width: 310px;
        }
    }
    @media ${device.laptop} {
        padding: 0em 0.75em 4em;

        .scroll-container {
            overflow: hidden;
        }
        .scroll {
            margin: 0 auto;
            width: 1100px;
        }
        h2 {
            text-align: center;
            width: 50%;
            margin: 0.25em auto;
            padding-left: 0.5em;
        }
        .box {
            width: 310px;
        }
    }
    @media ${device.desktop} {
        margin-left: -8em;
        .quote {
            top: 2.3em;
        }
        p {
            font-size: 22px;
            margin-bottom: 0.5em;
        }
        span {
            font-size: 22px;
        }
        .box {
            margin: 1em;
            padding-top: 4em;
            width: 400px;
            height: 380px;
        }
    }
`;

export const HomeTestimonials: React.FC = () => {
    return (
        <StyledHomeTestimonials>
            <h2>Words from our smiling patients</h2>
            <div className="scroll-container">
                <div className="scroll">
                    {reviews.map(review => {
                        return (
                            <>
                                <div className="container">
                                    <StaticImage
                                        className="quote"
                                        src="../images/svgs/quote.svg"
                                        placeholder="none"
                                        alt="blue quotation"
                                    />
                                    <div className="box">
                                        <p>{review.review}</p>
                                        <span>{review.name}</span>
                                    </div>
                                </div>
                            </>
                        );
                    })}
                </div>
            </div>
        </StyledHomeTestimonials>
    );
};
